<template>
  <div>
    <!-- Loading Message -->
    <div v-if="isLoading" class="bg-gray-100 p-2 rounded-md text-center my-2">
      {{ loadingText || 'Please wait' }}
    </div>

    <div class="flex flex-col gap-3 md:p-4" :class="recentLocations.length === 0 ? 'pb-2' : ''">
      <!-- Header -->
      <div class="flex flex-col gap-1">
        <h2 class="text-gray-900 font-medium text-lg">
          Select Delivery Location
        </h2>
      </div>

      <!-- Components for Finding Location -->
      <V2LocationFinderComponent @success="navigate" @error="handleError" />

      <V2GeolocationComponent @success="navigate" @error="handleError" />

      <V2SavedAddressForm @close="emit('close')" />

    </div>

  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { GoogleAnalytics } from "~/google_analytics/events";
import { EventParameter } from "~/google_analytics/events.enum";
import type { Address } from "~/types/address";
import { getRecentAddresses } from "~/utility/location/recent.location.storage";

const emit = defineEmits(["success", "close"]);

const isLoading = ref(false);
const loadingText = ref("");
const recentLocations = ref<Address[]>([]);

const navigate = async () => {
  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
    emit("success");
  }, 1000);
};

const handleError = (message: any) => {
  loadingText.value = message;
  isLoading.value = true;
};

onMounted(async () => {
  recentLocations.value = getRecentAddresses();
  GoogleAnalytics.popUpView({
    [EventParameter.POP_UP_NAME]: 'location_picker',
    [EventParameter.POP_UP_TITLE]: 'select_delivery_location'
  })
});

</script>
